import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ParentProfileLayout from './ParentProfileLayout';

// import utility file
import { Card, Col, Image, Row } from 'react-bootstrap';
import { Avatar } from '../../../elements/bootstrap/Avatar';
import EleveService from '../../services/EleveService';
import ParentService from '../../services/ParentService';
import SalledeclasseService from '../../services/SalledeclasseService';

const ViewChildren = () => {
	const { id } = useParams();
	const [parent, setParent] = useState(null);
	const [eleves, setEleves] = useState([]);
	const [salledeclasse, setSalledeclasse] = useState([]);

	useEffect(() => {
		const fetchParent = async () => {
			try {
				const response = await ParentService.getParent(id);
				setParent(response.data);
			} catch (error) {
				console.error('Error fetching parent data', error);
			}
		};

		const fetchEleves = async () => {
			try {
				const response = await EleveService.getAllEleves();
				setEleves(response);
			} catch (error) {
				console.error('Error fetching eleves data', error);
			}
		};

		const fetchSalledeclasse = async () => {
			try {
				const response = await SalledeclasseService.getAllSalledeclasse();
				setSalledeclasse(response);
			} catch (error) {
				console.error('Error fetching salledeclasse data', error);
			}
		};

		fetchParent();
		fetchEleves();
		fetchSalledeclasse();
	}, [id]);

	const formatValue = (value, columnId) => {
		if (typeof value === 'string') {
			if (columnId === 'nom' || (columnId === 'matricule' && value)) {
				return value.toUpperCase();
			} else if (columnId === 'statut_eleve' || columnId === 'genre') {
				return (
					value && value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
				);
			} else {
				return value;
			}
		} else if (columnId === 'salledeclasse') {
			const salle = salledeclasse.find((item) => item.id === value);
			return salle ? salle.intitule_classe.toUpperCase() : '';
		}
		return value;
	};

	const formatStatutEleve = (value) => {
		const formattedValue = value
			.replace(/_/g, ' ')
			.replace(/\b\w/g, (c) => c.toUpperCase());
		return formattedValue;
	};

	const getSalledeclasseById = (salledeclasseId) => {
		return salledeclasse.find((item) => item.id === salledeclasseId) ?? {};
	};

	const studentsWithSalledeclasse = eleves
		.filter((eleve) => parent && parent.eleves.includes(eleve.id))
		.map((eleve) => ({
			...eleve,
			salledeclasse: getSalledeclasseById(eleve.salledeclasse)
		}));

	const getInitials = (eleve) => {
		const firstName = eleve.prenom ? eleve.prenom.charAt(0).toUpperCase() : '';
		const lastName = eleve.nom ? eleve.nom.charAt(0).toUpperCase() : '';
		return `${lastName} ${firstName}`;
	};

	const displayEleves = studentsWithSalledeclasse.map((eleve) => {
		const initials = getInitials(eleve);
		return (
			<Col xl={6} lg={12} md={12} sm={12} key={eleve.id}>
				<Card className="mb-5">
					<Card.Body>
						<div className="text-center">
							<div className="position-relative mb-2">
								<Link to={`/education/eleves/${eleve.id}`}>
									{eleve.photo ? (
										<Image
											src={eleve.photo}
											alt=""
											className="rounded-circle avatar-xl"
										/>
									) : (
										<Avatar
											type="initial"
											size="xl"
											name={initials}
											className="rounded-circle"
											alt={initials}
										/>
									)}
								</Link>
							</div>
							<Link to={`/education/eleves/${eleve.id}`}>
								<h4 className="mb-0">{formatValue(eleve.nom, 'nom')}</h4>
							</Link>
							<p className="mb-0">
								{formatValue(eleve.matricule, 'matricule')}
							</p>
						</div>
						<div className="d-flex justify-content-between border-bottom py-2 mt-6">
							<span>Genre</span>
							<span className="text-dark">
								{formatValue(eleve.genre, 'genre')}
							</span>
						</div>
						<div className="d-flex justify-content-between border-bottom py-2">
							<span>Statut</span>
							<span>{formatStatutEleve(eleve.statut_eleve)}</span>
						</div>
						<div className="d-flex justify-content-between pt-2">
							<span>Classe</span>
							<span className="text-dark">
								{formatValue(eleve.salledeclasse.id, 'salledeclasse')}
							</span>
						</div>
					</Card.Body>
				</Card>
			</Col>
		);
	});

	return (
		<ParentProfileLayout>
			<Row>
				{displayEleves.length > 0 ? (
					displayEleves
				) : (
					<Col>Aucun élève associé à ce parent.</Col>
				)}
			</Row>
		</ParentProfileLayout>
	);
};

export default ViewChildren;
